import { render } from "./amount-status.vue?vue&type=template&id=7b66144c"
import script from "./amount-status.vue?vue&type=script&lang=js"
export * from "./amount-status.vue?vue&type=script&lang=js"

import "./amount-status.vue?vue&type=style&index=0&id=7b66144c&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__